import { defineComponent, onMounted } from 'vue';

import ScholarshipOverviewCode from '@/presentation/pages/scholarship-overview.class';

export default defineComponent({
	setup: () => {
		const code = new ScholarshipOverviewCode();

		onMounted(() => code.mounted());

		return {
			...code,
			toEditScholarship: code.toEditScholarship.bind(code),
			toCreateScholarship: code.toCreateScholarship.bind(code),
			jump: code.jump.bind(code),
			search: code.search.bind(code),
		};
	},
});
